import { TOGGLE_SIDEBAR, CLOSE_SIDEBAR, TRAINING_MODE_OFF, TRAINING_MODE_ON } from './actionTypes';

export const toggleSidebar = () => ({ type: TOGGLE_SIDEBAR });

export const closeSidebar = () => ({ type: CLOSE_SIDEBAR });

export const turnTrainingModeOff = () => ({ type: TRAINING_MODE_OFF });

export const turnTrainingModeOn = () => ({ type: TRAINING_MODE_ON });
